<template>
  <div class="planning-view planning">
    <div v-if="loadingInitial" class="loading-initial">
      Chargement de la gestion de planning...
    </div>

    <div v-else-if="initialError" class="error-initial alert alert-danger">
      {{ initialError }}
      <button class="btn btn-primary" @click="redirectToPlanning">
        Réessayer
      </button>
    </div>

    <div v-else class="planning-content">
      <router-view/>
    </div>

    <!-- Modal affichée si plusieurs choix -->
    <PlanningChoiceModal
        v-if="choiceModalVisible"
        :options="choiceOptions"
        @close="choiceModalVisible = false"
        @select="handleChoiceSelect"
    />
  </div>
</template>

<script setup>
import {onMounted, ref} from 'vue'
import {useRouter} from 'vue-router'
import '@/assets/styles/global.css'
import PlanningChoiceModal from '@/components/Planning/PlanningChoiceModal.vue'
import PlanningApi from "@/api/PlanningApi";
import RouteEnum from "@/router/RouteEnum";
import {usePlanningStore} from '@/store/planningStore'

const router = useRouter()
const planningStore = usePlanningStore()
const loadingInitial = ref(true)
const initialError = ref(null)
const ofObjId = ref(null)
const choiceModalVisible = ref(false)
const choiceOptions = ref([])

onMounted(async () => {
  await initializePlanning()
})

const initializePlanning = async () => {
  try {
    loadingInitial.value = true
    initialError.value = null

    const userAccountObjId = router.currentRoute.value.params.userAccountObjId
    const ofObjIdParams = router.currentRoute.value.params.ofObjId

    const response = await PlanningApi.getIndex(userAccountObjId, ofObjIdParams)

    if (Array.isArray(response.data)) {
      // Cas multiple -> on affiche la modal
      choiceOptions.value = response.data
      choiceModalVisible.value = true
      loadingInitial.value = false
    } else if (response.data.redirectUrl) {
      // Cas unique -> redirection directe (on ne passe jamais loadingInitial à false)
      const ofIdMatch = response.data.redirectUrl.match(
          /\/api\/planning\/(\d+)\/\d+\/planning\/getList/
      )
      if (ofIdMatch) {
        ofObjId.value = parseInt(ofIdMatch[1])
        return router.replace({
          name: RouteEnum.PLANNING_LIST,
          params: {
            ofObjId: ofObjId.value,
            userAccountObjId: userAccountObjId
          }
        })
      }
    } else {
      // si aucun résultat, on arrête le loader sinon il reste bloqué
      loadingInitial.value = false
    }
  } catch (err) {
    console.error("Erreur lors de l'initialisation du planning:", err)
    initialError.value =
        err.response?.data?.msg || 'Erreur lors du chargement du planning'
    loadingInitial.value = false
  }
}

const handleChoiceSelect = (url) => {
  const userAccountObjId = router.currentRoute.value.params.userAccountObjId
  const ofIdMatch = url.match(/\/api\/planning\/(\d+)\/\d+\/planning\/getList/)
  if (ofIdMatch) {
    ofObjId.value = parseInt(ofIdMatch[1])
    choiceModalVisible.value = false
    planningStore.preloadDone = false
    router.replace({
      name: RouteEnum.PLANNING_LIST,
      params: {
        ofObjId: ofObjId.value,
        userAccountObjId: userAccountObjId
      }
    })
  }
}

const redirectToPlanning = () => {
  initializePlanning()
}
</script>
